"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorOfAuthorOutsideAnyProvider = exports.RedlineAuthorColorsValueProvider = exports.InsideRedlinePreview = void 0;
exports.ourSideAuthorRuleFor = ourSideAuthorRuleFor;
exports.useCurrentUserInsideRedlineColor = useCurrentUserInsideRedlineColor;
exports.useRedlineAuthorColor = useRedlineAuthorColor;
exports.useRedlineAuthorColors = useRedlineAuthorColors;
var _react = _interopRequireWildcard(require("react"));
var _revision = require("@common/utils/redline/ooxml/revision");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _redlineAuthorColors = require("@common/utils/redlineAuthorColors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DIOPTRA_AUTHOR_KEY = _revision.Revision.authorKey(_redlineEngine.DIOPTRA_AUTHOR);
var CARD_NUMBER_AUTHOR = /^#\d+$/;
function ourSideAuthorRuleFor(orgMemberNames) {
  var orgMemberKeys = new Set(orgMemberNames.map(function (name) {
    return _revision.Revision.authorKey(name);
  }));
  return function (authorKey) {
    return authorKey === DIOPTRA_AUTHOR_KEY || CARD_NUMBER_AUTHOR.test(authorKey) || orgMemberKeys.has(authorKey);
  };
}
var COLORS_OUTSIDE_ANY_PROVIDER = new _redlineAuthorColors.RedlineAuthorColors({
  currentUserName: "",
  documentAuthors: [],
  isOurSideAuthor: ourSideAuthorRuleFor([])
});
var colorOfAuthorOutsideAnyProvider = exports.colorOfAuthorOutsideAnyProvider = function colorOfAuthorOutsideAnyProvider(authorName) {
  return COLORS_OUTSIDE_ANY_PROVIDER.colorOf(authorName);
};
var RedlineAuthorColorsContext = /*#__PURE__*/(0, _react.createContext)(COLORS_OUTSIDE_ANY_PROVIDER);
var RedlineAuthorColorsValueProvider = exports.RedlineAuthorColorsValueProvider = function RedlineAuthorColorsValueProvider(_ref) {
  var colors = _ref.colors,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RedlineAuthorColorsContext.Provider, {
    value: colors,
    "data-sentry-element": "RedlineAuthorColorsContext.Provider",
    "data-sentry-component": "RedlineAuthorColorsValueProvider",
    "data-sentry-source-file": "RedlineAuthorColorsContext.tsx",
    children: children
  });
};
var InsideRedlinePreviewContext = /*#__PURE__*/(0, _react.createContext)(false);
var InsideRedlinePreview = exports.InsideRedlinePreview = function InsideRedlinePreview(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(InsideRedlinePreviewContext.Provider, {
    value: true,
    "data-sentry-element": "InsideRedlinePreviewContext.Provider",
    "data-sentry-component": "InsideRedlinePreview",
    "data-sentry-source-file": "RedlineAuthorColorsContext.tsx",
    children: children
  });
};
function useRedlineAuthorColors() {
  return (0, _react.useContext)(RedlineAuthorColorsContext);
}
function useRedlineAuthorColor() {
  var colors = useRedlineAuthorColors();
  var insideRedlinePreview = (0, _react.useContext)(InsideRedlinePreviewContext);
  return (0, _react.useMemo)(function () {
    return function (authorName) {
      return insideRedlinePreview && colors.isCurrentUser(authorName) ? colors.currentUserInsideRedlineColor : colors.colorOf(authorName);
    };
  }, [colors, insideRedlinePreview]);
}
function useCurrentUserInsideRedlineColor() {
  return useRedlineAuthorColors().currentUserInsideRedlineColor;
}